import React from "react";
import {
  Typography,
  Grid,
  TextField,
  InputAdornment,
  Avatar,
  Box,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const inputStyles = {
  borderRadius: "50px",
  boxShadow: "0.5px 3px 10px 0px #7777771A",
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "50px",
    borderColor: "#ccc",
  },
  "& .MuiInputBase-input": {
    color: "#6A707E",
    fontSize: "16px",
    fontWeight: 600,
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#6A707E",
  },
  "& .MuiInputLabel-root": {
    color: "#6A707E",
    fontSize: "16px",
    fontWeight: 600,
  },
};

const TeamFormFields = ({ editedTeam, handleInputChange }) => {
  const dropdownAdornment = (
    <InputAdornment position="end">
      <KeyboardArrowDownIcon />
    </InputAdornment>
  );

  return (
    <Box sx={{ flex: 1 }}>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Name
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="name"
            value={editedTeam.teamName}
            onChange={handleInputChange}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Nickname
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="nickname"
            value={editedTeam.nickname}
            onChange={handleInputChange}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Tri-code
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="number"
            value={editedTeam.triCode}
            onChange={handleInputChange}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            City
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="position"
            value={editedTeam.city}
            onChange={handleInputChange}
            InputProps={{ endAdornment: dropdownAdornment }}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Sport
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="sport"
            value={editedTeam.sport}
            onChange={handleInputChange}
            InputProps={{ endAdornment: dropdownAdornment }}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            League
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="league"
            value={editedTeam.league}
            onChange={handleInputChange}
            InputProps={{ endAdornment: dropdownAdornment }}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Feed ID
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="id"
            value={editedTeam.id}
            onChange={handleInputChange}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Nationality
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="nationality"
            value={editedTeam.country}
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Avatar
                    src={editedTeam.nationalityFlag}
                    alt={editedTeam.nationality}
                    sx={{ width: 24, height: 24 }}
                  />
                </InputAdornment>
              ),
              endAdornment: dropdownAdornment,
            }}
            sx={inputStyles}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TeamFormFields;
